import React from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { Building, Users, TrendingUp, Plus } from 'lucide-react';
export function LandlordDashboard() {
  return <DashboardLayout userType="landlord" data-id="element-724">
      <div className="flex justify-between items-center mb-8" data-id="element-725">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-726">Property Overview</h2>
        <Button data-id="element-727">
          <Plus className="w-4 h-4 mr-2" data-id="element-728" />
          Add Property
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-729">
        <Card data-id="element-730">
          <CardContent className="p-6" data-id="element-731">
            <div className="flex justify-between items-start mb-4" data-id="element-732">
              <div className="bg-amber-100 p-2 rounded-lg text-amber-600" data-id="element-733">
                <Building className="w-6 h-6" data-id="element-734" />
              </div>
              <Badge variant="success" data-id="element-735">+12%</Badge>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-736">4</div>
            <div className="text-slate-500 text-sm" data-id="element-737">Active Properties</div>
          </CardContent>
        </Card>

        <Card data-id="element-738">
          <CardContent className="p-6" data-id="element-739">
            <div className="flex justify-between items-start mb-4" data-id="element-740">
              <div className="bg-indigo-100 p-2 rounded-lg text-indigo-600" data-id="element-741">
                <Users className="w-6 h-6" data-id="element-742" />
              </div>
              <Badge variant="success" data-id="element-743">98%</Badge>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-744">42</div>
            <div className="text-slate-500 text-sm" data-id="element-745">Total Tenants</div>
          </CardContent>
        </Card>

        <Card data-id="element-746">
          <CardContent className="p-6" data-id="element-747">
            <div className="flex justify-between items-start mb-4" data-id="element-748">
              <div className="bg-emerald-100 p-2 rounded-lg text-emerald-600" data-id="element-749">
                <TrendingUp className="w-6 h-6" data-id="element-750" />
              </div>
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-751">₦12.5M</div>
            <div className="text-slate-500 text-sm" data-id="element-752">Annual Revenue</div>
          </CardContent>
        </Card>
      </div>

      <Card className="mb-8" data-id="element-753">
        <CardHeader data-id="element-754">
          <CardTitle data-id="element-755">Active Listings</CardTitle>
        </CardHeader>
        <div className="overflow-x-auto" data-id="element-756">
          <table className="w-full text-sm text-left" data-id="element-757">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-758">
              <tr data-id="element-759">
                <th className="px-6 py-4" data-id="element-760">Property Name</th>
                <th className="px-6 py-4" data-id="element-761">Location</th>
                <th className="px-6 py-4" data-id="element-762">Occupancy</th>
                <th className="px-6 py-4" data-id="element-763">Status</th>
                <th className="px-6 py-4" data-id="element-764">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-765">
              {[{
              name: 'Emerald Heights',
              loc: 'Unilag, Akoka',
              occ: '12/12',
              status: 'Full'
            }, {
              name: 'Sunshine Lodge',
              loc: 'Yaba Tech',
              occ: '8/10',
              status: 'Available'
            }, {
              name: 'The Haven',
              loc: 'Bariga',
              occ: '15/20',
              status: 'Available'
            }].map((prop, idx) => <tr key={idx} className="hover:bg-slate-50" data-id="element-766">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-767">
                    {prop.name}
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-768">{prop.loc}</td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-769">{prop.occ}</td>
                  <td className="px-6 py-4" data-id="element-770">
                    <Badge variant={prop.status === 'Full' ? 'success' : 'warning'} data-id="element-771">
                      {prop.status}
                    </Badge>
                  </td>
                  <td className="px-6 py-4" data-id="element-772">
                    <Button variant="ghost" size="sm" className="text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50" data-id="element-773">
                      Manage
                    </Button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </DashboardLayout>;
}